import {createApp} from 'vue'
import options from './PersonalFundraisingFlowStepHero.options'

const el = '.kb-component--personal-fundraising-flow-step-hero'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((PersonalFundraisingFlowStepHeroDOM)=>{
            options.template = PersonalFundraisingFlowStepHeroDOM.innerHTML
            const component = createApp(options).use(Store)
            component.mount(PersonalFundraisingFlowStepHeroDOM)
        })
    }
}

